module.exports = __webpack_public_path__ + "d82ec6441cc51a924ddaf3762c42ff4b.svg";